<template>
    <aside v-if="hasHeadings" class="cms-headings w-50 hidden xl:block">
        <div class="sticky top-20 pt-4 space-y-2 overflow-y-auto max-h-[calc(100dvh-(--spacing(20)))]">
            <h3>{{ translateMe("On This Page") }}</h3>
            <ul>
                <li v-for="heading in visibleHeadings" :key="heading.slug" :class="heading.class">
                    <a class="py-1.5 block" :class="{ 'font-bold': heading.slug === activeId }" :href="heading.href">
                        {{ heading.text }}
                    </a>
                </li>
            </ul>
        </div>
    </aside>
</template>
<script setup lang="ts">
import { useActiveScroll } from "vue-use-active-scroll";

const { document } = defineProps<{ document: CMSDocument }>();

const DEPTH_CLASS = ["ml-0", "ml-4", "ml-8"];

const visibleHeadings = computed(() =>
    document.headings
        ?.filter((heading) => heading.depth > 1 && heading.depth < 5) // only h2, h3, or h4 headings
        .map((heading) => ({ ...heading, class: DEPTH_CLASS[heading.depth - 2], href: "#" + heading.slug }))
);

const hasHeadings = computed(() => Array.isArray(visibleHeadings.value) && visibleHeadings.value.length > 0);

const slugs = computed(() => visibleHeadings.value?.map((h) => h.slug) ?? []);

const { activeId } = useActiveScroll(slugs, {
    jumpToFirst: false,
    edgeOffset: { first: 0, last: 0 },
    overlayHeight: 88, // matches scroll-margin-top: calc(var(--spacing) * 22) = 5.5rem = 88px
});
</script>
